<template>
  <div class="learnDBC" :class="{lan_En : lan != 'zh'}">
    <div class="bg1"><img src="../../assets/home/cont4_bg1.jpg" alt=""></div>
    <div class="content1">
      <div class="cont1_left">
        <p class="left_text">{{ $t('learnDBC.title1') }}</p>
        <p class="left_text gradient_text">{{ $t('learnDBC.title2') }}</p>
      </div>
      <div class="cont1_right">
        <div class="right_list">
          <div class="right_li delay100 animateHide" v-animate="{delay: 100, class:'fadeInUp'}">
            <div class="token_icon1"></div>
            <div class="token_text"><span class="icon"></span><p>{{ $t('learnDBC.text1') }}</p></div>
          </div>
          <div class="right_li delay500 animateHide" v-animate="{delay: 500, class:'fadeInUp'}">
            <div class="token_text"><span class="icon"></span><p>{{ $t('learnDBC.text4') }}</p></div>
          </div>
        </div>
        <div class="right_list">
          <div class="right_li delay200 animateHide" v-animate="{delay: 200, class:'fadeInUp'}">
            <div class="token_text"><span class="icon"></span><p>{{ $t('learnDBC.text3') }}</p></div>
            <div class="token_text"><span class="icon"></span><p>{{ $t('learnDBC.text2') }}</p></div>
          </div>
          <div class="right_li delay700 animateHide" v-animate="{delay: 700, class:'fadeInUp'}">
            <div class="token_icon2"></div>
            <div class="token_text"><span class="icon"></span><p>{{ $t('learnDBC.text5') }}</p></div>
            <div class="token_text"><span class="icon"></span><p>{{ $t('learnDBC.text6') }}</p></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // @ is an alias to /src
  import { defineComponent, ref, computed, watch, onMounted  } from "vue";
  import { useStore } from "vuex"
  export default defineComponent({
    name: 'learnDBC',
    setup() {
      const store = useStore()
      let lan = computed(() =>  store.state.lan)
      watch(lan, (newvlaue, oldvalue) => {
        console.log(newvlaue, oldvalue, 'ssss');
      })
      onMounted(() => {

      });
      return {
        lan,
      };
    }
  })
</script>

<style lang="scss" scoped>
.learnDBC {
  min-width: 1200px;
  margin: auto;
  font-style: normal;
  // font-family: "Noto Sans SC";
  width: 100%;
  overflow: hidden;
  position: relative;
  .bg1 {
    position: absolute;
    top: -500px;
    margin: auto;
    width: 1920px;
    height: 1690px;
    left: 50%;
    transform: translateX(-50%);
    img {
      width: 1920px;
      height: 1690px;
    }
  }
  .cont_title {
    font-size: 48px;
    font-weight: 500;
    text-align: center;
    line-height: normal;
    margin-bottom: 40px;
    letter-spacing: 1.6px;
  }
  .cont_desc {
    max-width: 1000px;
    font-size: 16px;
    color: #899AA9;
    font-weight: 400;
    line-height: 24px; 
    text-align: center;
    letter-spacing: 1px;
  }
  .content1 {
    position: relative;
    width: 1200px;
    margin: auto;
    display: flex;
    padding: 80px 0 100px;
    box-sizing: border-box;
    justify-content: space-between;
    .cont1_left {
      width: 440px;
      padding-top: 160px;
      .left_text {
        color: #fff;
        font-size: 48px;
        font-weight: 500;
        line-height: normal;
        margin-bottom: 10px;
        letter-spacing: 0.96px;
      }
    }
    .cont1_right {
      width: 720px;
      display: flex;
      justify-content: space-between;
      .right_list {
        width: 348px;
        .right_li {
          width: 348px;
          padding: 24px;
          margin-bottom: 24px;
          box-sizing: border-box;
          border-bottom: 2px solid;
          background: rgba(16, 19, 47, .6);
          border-image: linear-gradient(to right, #36FFCF, #438EFF) 1;
          .token_text {
            display: flex;
            font-size: 16px;
            color: #899AA9;
            font-weight: 400;
            line-height: 24px;
            margin-top: 16px;
            justify-content: space-between;
            .icon {
              width: 12px;
              height: 12px;
              margin-top: 6px;
              background: url(../../assets/home/cont5_icon.png) 100%/100% no-repeat;
            }
            p {
              width: 270px;
            }
          }
          .token_icon1 {
            width: 160px;
            height: 158px;
            margin: 0 0 20px 20px;
            background: url(../../assets/learn/learn_img1.png) 100%/100% no-repeat;
          }
          .token_icon2 {
            width: 92px;
            height: 101px;
            margin-bottom: 0 0 10px 10px;
            background: url(../../assets/learn/learn_img2.png) 100%/100% no-repeat;
          }
        }
      }
    }
  }
}
</style>
